var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details__status get-height",class:("details__status--" + _vm.statusCssClass)},[_vm._v("\n  "+_vm._s(_vm.status ? _vm.$t((_vm.namespace + "." + _vm.status)) : '-')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }